
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import WorkcenterList from '@/components/workcenter/WorkcenterList.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import { EXPORT_WORKCENTERS, FETCH_WORKCENTERS, SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { FILTER_DEBOUNCE_TIME } from '@/utils/constants'
import errorHandler from '@/utils/errorHandler'
import { EExportType, ESmartBarcodeMenu } from '@/utils/enums'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import debounce from 'lodash/debounce'

interface IWorkcenterSearch {
  code?: string
  sortBy?: string
  sortType?: string
  [key: string]: string | undefined
}

@Options({
  components: { PageHeader, ItemNotFound, WorkcenterList },
  name: ESmartBarcodeMenu.WORK_CENTERS,
})
export default class Workcenters extends Mixins(DataTableMixin) {
  dataSearch: IWorkcenterSearch = {}
  debounceFilter!: () => void

  get isWorkcenterLoading(): boolean {
    return this.$store.getters.isWorkcenterLoading || false
  }

  get getWorkcenterTotalRecords(): number {
    return this.$store.getters.getWorkcenterTotalRecords || 0
  }

  get getWorkcenters() {
    return this.$store.getters.getWorkcenters || []
  }

  refreshWorkcenterList() {
    this.debounceFilter()
  }

  currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    this.redirectIndex()
    this.fetchList()
  }

  async exportCSV() {
    try {
      await this.$store.dispatch(EXPORT_WORKCENTERS, {
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.MASTER_DATA, isHaveNew: true })
    } catch (e) {
      errorHandler(e)
    }
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.dataSearch.sortBy = data.prop
    this.dataSearch.sortType = data.order ? (data.order === 'ascending' ? 'asc' : 'desc') : undefined
    this.currentPageNum = 1
    this.redirectIndex()
    this.fetchList()
  }

  fetchList() {
    try {
      this.$store.dispatch(FETCH_WORKCENTERS, {
        page: this.currentPageNum,
        limit: this.itemsPerPage,
        code: this.dataSearch.code || '',
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
    } catch (e) {
      errorHandler(e)
    }
  }

  get isMarumiyaPackage() {
    return this.$store.getters.isMarumiyaPackage
  }

  created() {
    if (this.isMarumiyaPackage) {
      this.$router.push({ name: 'home' })
      return
    }
    this.routeName = 'work-centers'
    this.getQueryData()
    this.debounceFilter = debounce(() => {
      this.currentPageNum = 1
      this.redirectIndex()
      this.fetchList()
    }, FILTER_DEBOUNCE_TIME)
    this.fetchList()
  }
}
